export var eventMessagesConstants = {
    EVENT_CREATED_SUCCESS: 'New event created successfully.',
    EVENT_EDITED_SUCCESS: 'Event edited successfully.',
    EVENT_DELETED_SUCCESS: 'Event deleted successfully.',
    EVENT_OVERRIDE_SUCCESS: 'Event override created successfully.',
};
